import { compile } from "path-to-regexp";

// If API call names does not start with PUT, POST, or DELETE, it
// means it is a GET request.

export const API = {
    ALL_LEADS: "/lead/all",
    COMPLETE_ONBOARDING: "/lead/complete-onboard/:id",
    PROCESSING_STAGES: "/client/processing/stages",
    READY_TO_SETTLE_STAGES: "/client/settlement/ready-to-settle-stages",
    DELETE_PROCESSING_STAGES: "/client/processing-stages/delete",
    CREATE_LEAD: "/lead/new",
    SINGLE_LEAD: "/lead/:id",
    DELETE_LEAD: "/lead/delete/:id",
    SINGLE_LEAD_OVERALL: "/lead/lead-overall/:id",
    PUT_SINGLE_LEAD: "/lead/update",
    UPDATE_DOCUMENT_PIN: "/documents/pin/:id",
    UPDATE_DOCUMENT_UNPIN: "/documents/unpin/:id",
    UPDATE_DOCUMENT_NAME: "/documents/update-name",
    UPDATE_DOCUMENT_TAG: "/documents/update-tag",
    LEAD_DOCUMENT_UPLOAD: "/lead/document/new",
    LEAD_DOCUMENT_VIEW: "/lead/document/view",
    LEAD_DOCUMENT_DELETE: "/lead/document/delete",
    LEAD_DOCUMENT_DOWNLOAD: "/lead/document/download",
    LEAD_DOCUMENT_ALL: "/lead/document/all", // requires query param of id,
    LEAD_DOCUMENT_UPDATE: "/lead/document/update/:id",
    LEAD_UNCONTACTED: "/lead/new/uncontacted",
    PUT_LEAD_CONVERT_CLIENT: "/lead/client-conversion/:id",
    PUT_LEAD_DETAIL: "/lead/details/update",
    LEAD_FINANCIAL_DISCLOSURE: "/lead/financial-disclosure/:id",
    LEAD_DELETE_BUSINESS: "/lead/business/delete",
    PUT_LEAD_FINANCIAL_DISCLOSURE: "/lead/financial-disclosure/update",
    CLIENT_DOCUMENT_UPLOAD: "/client/document/new",
    CLIENT_DOCUMENT_UPDATE: "/client/document/update/:id",
    CLIENT_DOCUMENT_DELETE: "/client/document/delete",
    CLIENT_DOCUMENT_VIEW: "/client/document/view",
    CLIENT_DOCUMENT_DOWNLOAD: "/client/document/download",
    CLIENT_DOCUMENT_ALL: "/client/document/all", // requires query param of id,
    CLIENT_RECEIPT_ALL: "/clients/:id/receipts",
    CLIENT_FINANCIAL_DISCLOSURE: "/client/financial-disclosure/:id",
    CLIENT_DELETE_BUSINESS: "/client/business/delete",
    PUT_CLIENT_FINANCIAL_DISCLOSURE: "/client/financial-disclosure/update",
    CLIENT_PAYMENTS: "/client/payment/:id",
    CLIENTS_PAYMENTS: "/clients/:clientId/payments",
    CLIENT_FEE_REFERENCES: "/v2/programs/:programId/fee-references",
    POST_CLIENT_CREATE_FEE: "/payments/fees",
    PUT_CLIENT_PAYMENTS: "/payments/plans/:id",
    PRINT_PAYMENT_TRANSACTION: "/payments/plans/:planId/transactions/:transactionId/print",
    SEND_RECEIPT_PAYMENT_TRANSACTION: "/clients/:clientId/receipts/send",
    GENERATE_RECEIPT_PAYMENT_TRANSACTION: "/clients/:clientId/receipts/generate",
    CLIENT_SETTLEMENT: "/client/settlement/:id",
    NOTIFY_CLIENT_SETTLEMENT: "/client/settlement/notify",
    CLIENT_SETTLEMENT_CREDIT_CARD: "/client/settlement/credit-card/:id",
    PUT_CLIENT_SETTLEMENT: "/client/settlement/update",
    CLIENT_PROCESSING: "/client/processing/:id",
    CLIENT_PROCESSING_RFV_LETTER: "/client/processing/rfv-letter",
    PUT_CLIENT_PROCESSING: "/client/processing/update",
    CLIENT_PROCESSING_PLATFORM_ACCESS: "/client/processing-access/:id",
    PUT_CLIENT_PROCESSING_PLATFORM_ACCESS: "/client/processing-access/update",
    DELETE_CLIENT_PROCESSING_PLATFORM_ACCESS: "/client/processing-access/delete",
    PUT_CLIENT_PROCESSING_AUDIT_NOTE: "/client/processing/audit_note/update",
    CLIENT_COMMISSIONS: "/v2/programs/client-commissions/clients/:clientId/commissions",
    PATCH_CLIENT_COMMISSION_AMOUNT: "/v2/programs/client-commissions/commissions/:id/amount",
    POST_CLIENT_COMMISSION_TRANSACTION:
        "/v2/programs/client-commissions/commissions/:id/transactions",
    CLIENT_PROGRAM: "/client/program/:id",
    PUT_CLIENT_PROGRAM: "/client/program/update",
    POST_CLIENT_PROGRAM: "/client/program/create",
    POST_CANCEL_CLIENT_PROGRAM: "/client/program/cancel",
    PUT_LEAD_PROGRAM: "/lead/program/update",
    LEAD_PROGRAM: "/lead/program/:id",
    DELETE_QUOTE_LEAD: "/lead/quote/delete",
    POST_LEAD_PROGRAM: "/lead/program/create",
    POST_CANCEL_LEAD_PROGRAM: "/lead/program/cancel",
    CLIENT_VIOLATION: "/client/violation/:id",
    PUT_CLIENT_VIOLATION: "/client/violation/update",
    PUT_CLAIM_VIOLATION: "/client/violation/claim",
    CLIENT_ACCOUNT: "/client/account/:id",
    CLIENT_PROGRAM_ACCOUNT: "/client/account/program/:id",
    PUT_CLIENT_ACCOUNT: "/client/account/update",
    CLIENT_TRADELINES: "/client/tradeline/:id",
    PUT_CLIENT_TRADELINES: "/client/tradeline/update",
    CLIENT_BANKRUPTCY: "/client/bankruptcy/:id",
    PUT_CLIENT_BANKRUPTCY: "/client/bankruptcy/update",
    CLIENT_FUNDING: "/client/funding/:id",
    PUT_CLIENT_FUNDING: "/client/funding/update",
    ALL_CLIENTS: "/client/all",
    ALL_CLIENTS_PROGRAMS: "/client/program-all",
    CREATE_CLIENT: "/client/new",
    SINGLE_CLIENT: "/client/:id",
    PUT_SINGLE_CLIENT: "/client/update",
    PUT_CLIENT_DETAIL: "/client/details/update",
    ALL_EMPLOYEES: "/employee/all",
    CREATE_EMPLOYEE: "/employee/new",
    SINGLE_EMPLOYEE: "/employee/:id",
    DELETE_EMPLOYEE: "/employee/delete/:id",
    PUT_SINGLE_EMPLOYEE: "/employee/update",
    EMPLOYEE_COMMISSION: "/employee/commission/:id",
    PUT_EMPLOYEE_COMMISSION: "/employee/commission/update",
    EMPLOYEE_DOCUMENT_ALL: "/employee/document/all", // requires query param of id,
    EMPLOYEE_DOCUMENT_UPLOAD: "/employee/document/new",
    EMPLOYEE_DOCUMENT_DELETE: "/employee/document/delete",
    EMPLOYEE_DOCUMENT_UPDATE: "/employee/document/update/:id",
    EMPLOYEE_DOCUMENT_VIEW: "/employee/document/view",
    EMPLOYEE_DOCUMENT_DOWNLOAD: "/employee/document/download",
    EMPLOYEE_SIMPLE_ALL_DROPDOWN: "/employee/dropdown",
    ALL_USERS: "/user/all",
    USERS_ROUND_ROBIN: "/user/round-robin",
    PUT_ROUND_ROBIN: "/user/update/round-robin",
    CREATE_USER: "/user/new",
    SINGLE_USER: "/user/:id",
    REAL_TIME_USERS: "/user/real-time/:id",
    PUT_SINGLE_USER: "/user/update",
    PUT_USER_DISABLED: "/user/disabled",
    PUT_USER_REASSIGN: "/user/reassign",
    PUT_USER_REASSIGN_MULTIPLE: "/user/reassign-multiple",
    POST_USER_REASSIGN_MULTIPLE_PREVIEW: "/user/reassign-multiple/preview",
    POST_USER_REASSIGN_MULTIPLE_COUNTS: "/user/reassign-multiple/counts",
    PUT_SINGLE_USER_PROFILE: "/user/profile",
    POST_IMAGE_PROFILE: "/user/profile-image",
    POST_NEW_USER: "/user/new",
    POST_PASSWORD_UPDATE: "/user/password",
    PROFILE: "/user/auth0/:id",
    USER_SIMPLE_ALL: "/user/simplified/all",
    USER_SIMPLE_ALL_DROPDOWN: "/user/dropdown/all",
    USER_SIMPLE_CALENDAR: "/user/dropdown/calendar",
    ADDRESS_AUTOCOMPLETE: "/address-autocomplete",
    DELETE_USER: "/user/delete/:id",
    DELETE_CLIENT: "/client/delete/:id",
    DELETE_ACCOUNT: "/client/account/delete",
    DELETE_CREDIT_CARD: "/client/credit-card/delete",
    DELETE_SETTLEMENT: "/client/settlement/delete",
    DELETE_TRADELINE: "/client/tradeline/delete",
    DELETE_FEE: "/payments/fees/:feeId",
    DELETE_FEE_TRANSACTION: "/payments/fees/:feeId/transactions/:transactionId",
    DELETE_TRANSACTION: "/payments/plans/:planId/transactions/:transactionId",
    DELETE_PROGRAM: "/client/program/delete",
    DELETE_QUOTE_CLIENT: "/client/quote/delete",
    DELETE_VIOLATION: "/client/violation/delete",
    DELETE_RE_TRANSACTION: "/payments/real-estate/transactions/:transactionId",
    DELETE_PROCESS: "/client/process/delete",
    DELETE_CREDIT_SCORES: "/client/credit-scores/delete",
    DELETE_CREDIT_LINE: "/client/funding/credit-line/delete",
    DELETE_LEAD_CREDIT_SCORES: "/lead/credit-scores/delete",
    DELETE_BANK_ACCESS: "/client/funding/bank-access/delete",
    ALL_LANGUAGES: "/language/all",
    ALL_LOCATIONS: "/location/all",
    ALL_ROLES: "/role/all",
    ALL_NOTES: "/note/all", // requires query param of id,
    POST_NOTE_NEW: "/note/new",
    LEAD_FLAG: "/lead/red-flag/:id",
    PUT_LEAD_FLAG: "/lead/red-flag/update",
    PUT_LEAD_RCS_ENABLED: "/lead/rcs-enabled/update",
    CLIENT_FLAG: "/client/red-flag/:id",
    PUT_CLIENT_FLAG: "/client/red-flag/update",
    PUT_CLIENT_RCS_ENABLED: "/client/rcs-enabled/update",
    LEAD_CHECKMARK: "/lead/checkmark/:id",
    PUT_LEAD_CHECKMARK: "/lead/checkmark/update",
    CLIENT_CHECKMARK: "/client/checkmark/:id",
    PUT_CLIENT_CHECKMARK: "/client/checkmark/update",
    ALL_ACTIVITIES: "/activity/all",
    SINGLE_CONTACT_ACTIVITIES: "/activity/single-contact",
    POST_PIN_ACTIVITY: "/activity/pin/:id",
    POST_UNPIN_ACTIVITY: "/activity/unpin/:id",
    SINGLE_ACTIVITY: "/activity/:id",
    /** English <-> Spanish translation of a Note (cached server-side on the note record). */
    TRANSLATE_NOTE: "/note/:id/translate",
    ALL_CONTACTS: "/contact/all",
    SINGLE_CONTACT: "/contact/:id",
    CONVERSATIONS: "/conversation",
    ALL_CONVERSATIONS: "/conversation/all",
    LAST_SENDERS_CONVERSATIONS: "/conversation/last-senders/names",
    SINGLE_CONVERSATIONS: "/conversation/:id",
    SINGLE_CONVERSATION_RESPONSIBLE: "/conversation/responsible/:conversationId",
    SINGLE_CONVERSATION_RESPONSIBLE_READ: "/conversation/responsible-read/:conversationId",
    SINGLE_CONVERSATION_WATCHER: "/conversation/watchers/:conversationId/:userId",

    SIGNED_URL: "/webhook/image_signed_url",
    CONTACT_NAMES: "/contact/names",
    SEND_EMAIL: "/message/email/send",
    SEND_SMS: "/message/sms/send",
    DELETE_CONVERSATIONS: "/conversation/delete/:id",
    // ALL_SERVICES: "/status/service/all",
    // ALL_GOALS: "/status/goal/all",
    // ALL_PROGRAMS: "/status/program/all",
    // ALL_SETTLEMENT_STATUS: "/status/settlement/all",
    // ALL_ACCOUNT_STATUS: "/status/account/all",

    // ! TASKS API ROUTES
    USER_TASK_GET: "/tasks/:id",
    USER_TASK_CREATE: "/tasks",
    USER_TASK_DELETE: "/tasks/:id",
    USER_TASK_UPDATE: "/tasks/:id",
    USER_TASKS_MONTH_SUMMARY: "/tasks/month/summary",
    USER_TASKS_PENDING_COUNT: "/tasks/pending/count",
    USER_TASKS_DAY_DETAIL: "/tasks/day/detail",
    USER_TASKS_WEEK_DETAIL: "/tasks/week/detail",
    USER_TASK_COMPLETE: "/tasks/:id/complete",
    USER_TASK_UNDO: "/tasks/:id/undo",
    USER_TASK_DISMISS: "/tasks/:id/dismiss",

    // ! APPOINTMENTS API ROUTES
    USER_APPOINTMENTS_MONTH_SUMMARY: "/appointments/month/summary",
    USER_APPOINTMENTS_PENDING_COUNT: "/appointments/pending/count",
    USER_APPOINTMENTS_CALENDAR_FEED: "/appointments/calendar-feed",
    USER_APPOINTMENTS_CALENDAR_FEED_REGENERATE: "/appointments/calendar-feed/regenerate",
    USER_APPOINTMENTS_CALENDAR_FEED_STATUS: "/appointments/calendar-feed/status",
    USER_APPOINTMENTS_DAY_DETAIL: "/appointments/day/detail",
    USER_APPOINTMENTS_WEEK_DETAIL: "/appointments/week/detail",
    USER_APPOINTMENT_ALL: "/appointment/month/all/:month",
    USER_APPOINTMENT_GET: "/appointments/:id", //"/appointment/:id",
    USER_APPOINTMENT_CREATE: "/appointments",//"/appointment/new",
    USER_APPOINTMENT_UPDATE: "/appointments/:id",//"/appointment/update",
    USER_APPOINTMENT_DELETE: "/appointments/:id",// "/appointment/delete",
    USER_APPOINTMENT_NO_SHOW_COUNT: "/appointments/no-show/count", // "/appointment/no-show/count",
    USER_APPOINTMENT_COMPLETE: "/appointments/:id/complete",
    USER_APPOINTMENT_NO_SHOW: "/appointments/:id/no-show",
    USER_APPOINTMENT_UNDO: "/appointments/:id/undo",


    CONTACT_SEARCH_ALL: "/contact/all/names",
    TEMPLATE_ALL: "/template/all",
    CREATE_TEMPLATE: "/template/new",
    SINGLE_TEMPLATE: "/template/:id",
    PUT_SINGLE_TEMPLATE: "/template/update",
    SINGLE_TEMPLATE_DELETE: "/template/delete",
    TEMPLATE_FOLDERS_ALL: "/template-folder/all",
    TEMPLATE_FOLDER_MY: "/template-folder/my-folder",
    TEMPLATE_FOLDER_SINGLE: "/template-folder/:id",
    TEMPLATE_FOLDER_NEW: "/template-folder/new",
    TEMPLATE_FOLDER_UPDATE: "/template-folder/update",
    TEMPLATE_FOLDER_DELETE: "/template-folder/delete",
    CAMPAIGN_ALL: "/campaign/all",
    SINGLE_CAMPAIGN: "/campaign/:id",
    SINGLE_CAMPAIGN_HISTORY: "/campaign/history/:id",
    CAMPAIGN_CREATE: "/campaign/new",
    PUT_SINGLE_CAMPAIGN: "/campaign/update",
    SINGLE_CAMPAIGN_DELETE: "/campaign/delete",
    PUT_CAMPAIGN_DISABLED: "/campaign/disabled",
    SEND_SMS_FILTER: "/campaign/sms/send_filter",
    SEND_EMAIL_FILTER: "/campaign/email/send_filter",
    SEND_SMS_BULK: "/campaign/sms/send",
    SEND_EMAIL_BULK: "/campaign/email/send",
    BULK_MESSAGE_FILTERS: "/campaign/bulk_filters",
    /** New unified recipients endpoint — accepts structured criteria, rejects legacy %-encoding. */
    POST_CAMPAIGN_RECIPIENTS: "/campaign/recipients",
    BULK_CONVERSATION_ALL: "/campaign/bulk/all",
    SINGLE_BULK_CONVERSATION: "/campaign/bulk/:id",
    CANCEL_BULK_CONVERSATION: "/campaign/bulk/:id/cancel",
    // GET_LOCATION: "https://cors-anywhere.herokuapp.com/https://api.geoapify.com/v1/geocode/search",
    GET_LOCATION: "/geoapify/:postcode",
    CITY_DROPDOWN_SEARCH: "/geoapify/city",
    SETTING_ALL: "/dynamic_list/all",
    SINGLE_SETTING: "/dynamic_list/:id",
    BY_NAME_SETTING: "/dynamic_list/name",
    NEW_DYNAMIC_LIST_VALUE: "/dynamic_list/new",
    SINGLE_SETTING_DELETE: "/dynamic_list/delete",
    PUT_DYNAMIC_LIST: "/dynamic_list/update",
    CREDITOR_ALL: "/creditor/all",
    PUT_CREDITOR: "/creditor/update",
    CR_PRICING: "/settings/cr_pricing",
    ALL_SETTINGS: "/settings/all",
    // CLRDC-2234: AI-assisted credit report analysis for CLUB programs
    ANALYZE_CREDIT_REPORT: "/credit-report-analysis/analyze",
    PUT_CR_PRICING: "/settings/cr_pricing/update",
    PUT_ANUAL_INTEREST: "/settings/anual_interest/update",
    NOTIFICATIONS: "/notification/all",
    NOTIFICATIONS_UNREAD: "/notification/unread",
    PUT_UNREAD_NOTIFICATION: "/notification/mark-unread/:id",
    PUT_READ_NOTIFICATION: "/notification/mark-read/:id",
    PUT_READ_ALL_NOTIFICATION: "/notification/mark-read/all",
    POST_PIN_NOTE: "/note/pin/:id",
    POST_UNPIN_NOTE: "/note/unpin/:id",
    UPDATE_NOTE: "/note/update",
    DELETE_NOTE: "/note/delete",
    GET_FILE: "/public/file/:id",
    // Real Estate Opportunities
    ALL_BUYER_OPPORTUNITIES: "/opportunities/buyer/all",
    SINGLE_BUYER_OPPORTUNITY: "/opportunities/buyer/:id",
    UPDATE_BUYER_OPPORTUNITY: "/opportunities/buyer/update",
    CREATE_BUYER_OPPORTUNITY: "/opportunities/buyer/create",
    DELETE_BUYER_OPPORTUNITY: "/opportunities/buyer/:id",
    ALL_BUYER_SELLER_OPPORTUNITIES: "/opportunities/buyer-seller/all",
    // Seller Opportunities
    ALL_SELLER_OPPORTUNITIES: "/opportunities/seller/all",
    SINGLE_SELLER_OPPORTUNITY: "/opportunities/seller/:id",
    UPDATE_SELLER_OPPORTUNITY: "/opportunities/seller/update",
    CREATE_SELLER_OPPORTUNITY: "/opportunities/seller/create",
    DELETE_SELLER_OPPORTUNITY: "/opportunities/seller/:id",
    // Credit Repair Opportunities
    ALL_CR_OPPORTUNITIES: "/opportunities/credit-repair/all",
    SINGLE_OPPORTUNITIY_CR: "/opportunities/credit-repair/:id",
    UPDATE_OPPORTUNITIY_CR: "/opportunities/credit-repair/update",
    CREATE_OPPORTUNITIY_CR: "/opportunities/credit-repair/create",
    DELETE_OPPORTUNITIY_CR: "/opportunities/credit-repair/:id",
    // Mortgage Opportunities
    ALL_MORTGAGE_OPPORTUNITIES: "/opportunities/mortgage/all",
    SINGLE_OPPORTUNITIY_MORTGAGE: "/opportunities/mortgage/:id",
    UPDATE_OPPORTUNITIY_MORTGAGE: "/opportunities/mortgage/update",
    CREATE_OPPORTUNITIY_MORTGAGE: "/opportunities/mortgage/create",
    DELETE_OPPORTUNITIY_MORTGAGE: "/opportunities/mortgage/:id",
    // Refinancing Opportunities
    ALL_REFINANCING_OPPORTUNITIES: "/opportunities/refinancing/all",
    SINGLE_OPPORTUNITY_REFINANCING: "/opportunities/refinancing/:id",
    UPDATE_OPPORTUNITY_REFINANCING: "/opportunities/refinancing/update",
    CREATE_OPPORTUNITY_REFINANCING: "/opportunities/refinancing/create",
    DELETE_OPPORTUNITY_REFINANCING: "/opportunities/refinancing/:id",
    // Convert Mortgage ↔ Refinancing
    CONVERT_MORTGAGE_TO_REFINANCING: "/opportunities/mortgage/:id/convert",
    CONVERT_REFINANCING_TO_MORTGAGE: "/opportunities/refinancing/:id/convert",
    // Combined Mortgage + Refinancing Opportunities
    ALL_MORTGAGE_REFINANCING_OPPORTUNITIES: "/opportunities/mortgage-refinancing/all",
    // HELOC Opportunities
    ALL_HELOC_OPPORTUNITIES: "/opportunities/heloc/all",
    SINGLE_OPPORTUNITY_HELOC: "/opportunities/heloc/:id",
    UPDATE_OPPORTUNITY_HELOC: "/opportunities/heloc/update",
    CREATE_OPPORTUNITY_HELOC: "/opportunities/heloc/create",
    DELETE_OPPORTUNITY_HELOC: "/opportunities/heloc/:id",
    // Opportunities by person
    OPPORTUNITIES_BY_PERSON: "/opportunities/by-person/:personId",
    // SIGN SIGNWELL
    GET_SIGN_TEMPLATES_SW: "/sign/templates",
    GET_SIGN_TEMPLATES_FIELDS_SW: "/sign/templates-fields",
    POST_SIGN_AGREEMENTS_FORM_SW: "/sign/form",
    GET_SIGN_TEMPLATES_LEADS_SW: "/sign/leads/templates",
    GET_SIGN_TEMPLATES_FIELDS_LEADS_SW: "/sign/leads/templates-fields",
    POST_SIGN_AGREEMENTS_FORM_LEADS_SW: "/sign/leads/form",
    GET_CONTACT_AGREEMENTS: "/sign/forms/:id",

    TUTORIALS: "/tutorials",
    TUTORIALS_BY_ID: "/tutorials/:id",

    MORTGAGE_PROGRAM_BY_ID: "/client/real-estate/mortgage/:id",
    REFINANCING_PROGRAM_BY_ID: "/client/real-estate/refinancing/:id",
    SELLER_PROGRAM_BY_ID: "/client/real-estate/seller/:id",
    BUYER_PROGRAM_BY_ID: "/client/real-estate/buyer/:id",
    PROPERTY_LIKED_BY_ID: "/client/real-estate/property-liked/:id",
    PROPERTY_LIKED: "/client/real-estate/property-liked",

    REFERRAL_AGENTS: "/referral-agents",
    REFERRAL_AGENTS_BY_ID: "/referral-agents/:id",

    // Lead Document Tag Catalog
    DOCUMENT_TAG_CATALOG: "/documents/document-tag-catalog",

    // Analytics
    ANALYTICS_QUESTION: "/analytics/question",
    CHAT_SESSIONS: "/chat-sessions",
    CHAT_SESSIONS_BY_ID: "/chat-sessions/:id",

    // Legal Texts (Terms & Privacy)
    LEGAL_TEXTS_LATEST: "/settings/legal-texts/latest",
    LEGAL_TEXTS_CREATE: "/settings/legal-texts",
    LEGAL_TEXTS_PENDING: "/settings/legal-texts/pending",
    LEGAL_TEXTS_ACCEPT: "/settings/legal-texts/accept",

    // Roles settings (default permissions & extra field values per role)
    ROLES_SETTINGS: "/settings/roles",
    ROLES_SETTINGS_SINGLE: "/settings/roles/:id",
    ROLES_DEFAULTS: "/settings/roles/defaults",
    
    // BUSINESS
    BUSINESSES: "/businesses",
    BUSINESSES_BY_ID: "/businesses/:id",
    BUSINESSES_ASSIGN_CONTACT_BY_ID: "/businesses/assign-contact/:id",
    BUSINESSES_NOTES: "/businesses/note/",
    BUSINESSES_NEW_NOTE: "/businesses/note/new",
    BUSINESSES_NOTE_BY_ID: "/businesses/note/:id",
    BUSINESSES_DOCUMENTS: "/businesses/document/all",
    BUSINESSES_NEW_DOCUMENT: "/businesses/document/new",
    BUSINESSES_DOCUMENT_BY_ID: "/businesses/document/:id",
    BUSINESSES_DOCUMENT_DELETE: "/businesses/document/delete",
    BUSINESSES_DOCUMENT_UPDATE: "/businesses/document/update/:id",
    BUSINESSES_VOE_BY_ID: "/businesses/voe/:id",
    BUSINESSES_VOE_NEW: "/businesses/voe/new",

    BUSINESSES_DOCUMENT_VIEW: "/businesses/document/view",
    BUSINESSES_DOCUMENT_DOWNLOAD: "/businesses/document/download",

    // Payment Methods
    DELETE_CLIENT_PAYMENT_METHOD: "/client/:id/payment-method/:paymentMethodId",
    CLIENT_SINGLE_PAYMENT_METHOD: "/client/:id/payment-method",
    CLIENT_PAYMENT_METHOD_OPTIONS: "/client/:id/payment-method/options",
    LEAD_SINGLE_PAYMENT_METHOD: "/lead/:id/payment-method",
    LEAD_PAYMENT_METHOD_OPTIONS: "/lead/:id/payment-method/options",

    // Pending Payments
    PENDING_PAYMENTS: "/payments/plans/pending",

    // Inquiries Stages
    INQUIRIES_STAGES: "/client/stages/inquiries",
    COMPLETE_INQUIRY_REMOVAL: "/client/stages/inquiries/:id/complete",

    // First Payment Stages
    FIRST_PAYMENT_STAGES: "/client/stages/first-payment",
    COMPLETE_FIRST_PAYMENT_STAGE: "/client/stages/first-payment/:id/complete",
    // Pause XP Stages
    PAUSE_XP_STAGES: "/client/stages/pause-xp",
    COMPLETE_PAUSE_XP_STAGE: "/client/stages/pause-xp/:id/complete",
    // Paid In Full Dashboard
    PAID_IN_FULL_DASHBOARD: "/client/stages/paid-in-full",
    COMPLETE_PAID_IN_FULL: "/client/stages/paid-in-full/:id/complete",

    //Credit Sales Reports
    CREDIT_SALES_REPORTS: "/analytics/reports/credit-sales",
    CREDIT_SALES_REPORTS_APPOINTMENTS: "/analytics/reports/credit-sales/appointments",
    CREDIT_SALES_REPORTS_APPOINTMENTS_AGENTS: "/analytics/reports/credit-sales/appointments/agents",
    CREDIT_SALES_REPORTS_QUOTES_AGENTS: "/analytics/reports/credit-sales/quotes/agents",
    CREDIT_SALES_REPORTS_QUOTES: "/analytics/reports/credit-sales/quotes",
    CREDIT_SALES_REPORTS_SOLDS: "/analytics/reports/credit-sales/solds",
    CREDIT_SALES_REPORTS_SOLDS_AGENTS: "/analytics/reports/credit-sales/solds/agents",
    CREDIT_SALES_REPORTS_SOLD_AMOUNT_AGENTS: "/analytics/reports/credit-sales/solds/amount/agents",
    CREDIT_SALES_REPORTS_SOLD_PROGRAMS: "/analytics/reports/credit-sales/solds/programs",
    CREDIT_SALES_REPORTS_CANCELED_AGENTS: "/analytics/reports/credit-sales/canceled/agents",

    // Telemarketing Reports
    TELEMARKETING_REPORTS_APPOINTMENTS: "/analytics/reports/telemarketing/appointments",
    TELEMARKETING_REPORTS_APPOINTMENTS_BY_AGENT: "/analytics/reports/telemarketing/appointments/agents",
    TELEMARKETING_REPORTS_APPOINTMENTS_OVERDUE: "/analytics/reports/telemarketing/appointments/overdue",
    TELEMARKETING_REPORTS_TOTAL_CALLS: "/analytics/reports/telemarketing/calls/total",
    TELEMARKETING_REPORTS_CALLS_BY_AGENT: "/analytics/reports/telemarketing/calls/agents",
    TELEMARKETING_REPORTS_MESSAGES_BY_AGENT: "/analytics/reports/telemarketing/messages/agents",
    TELEMARKETING_REPORTS_LEADS_AND_CLIENTS: "/analytics/reports/telemarketing/agents/contacts",

    // Re-commissions Reports
    RE_COMMISSIONS_OVERVIEW: "/analytics/reports/re-commissions/overview",
    RE_COMMISSIONS_LIST: "/analytics/reports/re-commissions/list",

    // Ads Analytics Reports
    ADS_ANALYTICS_OVERVIEW: "/analytics/reports/ads-analytics/overview",
    ADS_ANALYTICS_BY_ADSET: "/analytics/reports/ads-analytics/by-adset",
    ADS_ANALYTICS_BY_AD: "/analytics/reports/ads-analytics/by-ad",
    ADS_ANALYTICS_PIPELINE_STAGE: "/analytics/reports/ads-analytics/pipeline-stage",
    ADS_ANALYTICS_OPPORTUNITIES_BY_PIPELINE: "/analytics/reports/ads-analytics/opportunities-by-pipeline",
    ADS_ANALYTICS_ADDITIONAL_METRICS: "/analytics/reports/ads-analytics/additional-metrics",
    ADS_ANALYTICS_LOSS_REASONS: "/analytics/reports/ads-analytics/loss-reasons",
    ADS_ANALYTICS_MISSING_ATTRIBUTION: "/analytics/reports/ads-analytics/missing-attribution",

    // Programs V2
    PROGRAM_CATALOG: "/v2/programs/catalog",
    PATCH_PROGRAM_EDIT: "/v2/programs/program/edit/:id",
    GET_HOLIDAYS: "/schedules/holidays",
    CREATE_HOLIDAY: "/schedules/holidays",
    UPDATE_HOLIDAY: "/schedules/holidays/:id",
    DELETE_HOLIDAY: "/schedules/holidays/:id",
    GET_VACATIONS: "/schedules/vacations",
    CREATE_VACATION: "/schedules/vacations",
    UPDATE_VACATION: "/schedules/vacations/:id",
    DELETE_VACATION: "/schedules/vacations/:id",
    GET_SCHEDULES: "/schedules/schedules",
    CREATE_SCHEDULE: "/schedules/templates",
    UPDATE_SCHEDULE: "/schedules/templates/:id",
    DELETE_SCHEDULE: "/schedules/templates/:id",
    UPSERT_ROTATION: "/schedules/rotations/:userId",
    GET_CALENDAR: "/schedules/calendar",
    UPSERT_CALENDAR_ENTRY: "/schedules/calendar/:userId/:date",
    PROPERTIES: "/properties",
    PROPERTY_BY_ID: "/properties/:propertyId",
    PROPERTY_FINANCINGS: "/properties/:propertyId/financings",
    PROPERTY_FINANCING_BY_ID: "/properties/:propertyId/financings/:financingId",

    // Tickets
    GET_TICKETS: "/tickets",
    CREATE_TICKET: "/tickets",
    SINGLE_TICKET: "/tickets/:id",
    UPDATE_TICKET_STATUS: "/tickets/:id/status",
    ASSIGN_TICKET: "/tickets/:id/assign",
    GET_TICKET_COMMENTS: "/tickets/:id/comments",
    CREATE_TICKET_COMMENT: "/tickets/:id/comments",
    TOGGLE_TICKET_VOTE: "/tickets/:id/vote",

    PROPERTY_FINANCING_LATES: "/properties/:propertyId/financings/:financingId/lates",
    PROPERTY_FINANCING_LATE_BY_ID: "/properties/:propertyId/financings/:financingId/lates/:lateId",
    PROPERTY_ESTIMATE_VALUE: "/properties/:propertyId/estimate-value",
    REFINANCE_CASH_OUT: "/properties/refinance-cash-out",

    // Attendance
    ATTENDANCE_CLOCK_IN: "/attendance/clock-in",
    ATTENDANCE_CLOCK_OUT: "/attendance/clock-out",
    ATTENDANCE_CURRENT_SESSION: "/attendance/current-session",
    ATTENDANCE_LIVE: "/attendance/live-attendance",
    ATTENDANCE_TIMECARD_REPORT: "/attendance/timecard-report",
    ATTENDANCE_TIMECARD_REPORT_PDF: "/attendance/timecard-report/pdf",
};

/**
 *
 * @param apiUrl in pathToRegexp format
 * @param params key value pairs to build url
 * @param baseUrl the  baseurl eg. http://localhost:3000.
 * @param query query params in object format eg. {id : 1234}
 * @returns a complete url.
 */
export const buildUrl = (apiUrl: string, params = {}, baseUrl = "", query = {}) => {
    // @ts-ignore
    return `${baseUrl}${compile(apiUrl, { encode: encodeURIComponent })(params)}${Object.keys(query).length ? "?" : ""
        }${new URLSearchParams(query).toString()}`;
};
